import { type FormStepKey, STEP_KEYS } from '@/features/futures/components/appropriateness-test-form-steps';
import { type AppropriatenessTestOrDefaults, appropriatenessTestQuestionsSchema } from '@/features/futures/schemas/appropriateness-test';

export const getStepIndex = (step: FormStepKey) => STEP_KEYS.indexOf(step);

export const getFirstUnansweredStep = (appropriatenessTest: AppropriatenessTestOrDefaults) => {
  const result = appropriatenessTestQuestionsSchema.safeParse(appropriatenessTest);
  if (result.success) return getStepIndex('confirmation');

  const firstError = result.error.issues[0];
  const firstUnansweredKey = firstError?.path[0]?.toString();
  if (!firstUnansweredKey) return getStepIndex('confirmation');

  return getStepIndex(firstUnansweredKey as FormStepKey);
};

export const hasUnansweredSteps = (appropriatenessTest: AppropriatenessTestOrDefaults) => {
  return !appropriatenessTestQuestionsSchema.safeParse(appropriatenessTest).success;
};
